(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('QuoteSearch', QuoteSearch);

    QuoteSearch.$inject = ['$resource'];

    function QuoteSearch($resource) {
        var resourceUrl =  'api/_search/quotes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
